<script>
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    }
  }
}
</script>

<template>
  <li class="vehicle-card-specs-list-item">
    <span>{{ name }}</span>
    <span>{{ value }}</span>
  </li>
</template>
